import SectionPassword from './SectionPassword';

export default SectionPassword;
